module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image01-42601f9665cb922948367005d87b11f9.png";